module.exports = __webpack_public_path__ + "static/cnn-periksadata-b9ed0517595243a0784a6328cdc8a009.jpeg";